<script>
import FavoriteComponent from 'Vue/Web/Shop/Course/FavoriteComponent.vue';
import MyMarkBlock from 'Vue/Web/Common/MyMarkBlock.vue';

import RecommendNoteComponent from 'Vue/Web/Common/RecommendNoteComponent.vue';
import RecommendCourseComponent from 'Vue/Web/Common/RecommendCourseComponent.vue';
import RecommendProductComponent from 'Vue/Web/Common/RecommendProductComponent.vue';

export default {
  name: 'ReadController',
  el: '.content',
  components: {
    MyMarkBlock,
    FavoriteComponent,
    RecommendNoteComponent,
    RecommendCourseComponent,
    RecommendProductComponent,
  },
  props: {
  },
  mounted() {
  },
  data() {
    return {
        item: Json.item,
    }},
  methods: {
    scrollToId(id, event) {
          event.preventDefault();
          const targetElement = document.getElementById(id);
          if (targetElement) {
              const offset = 200; // 假設你的頭部導航條高度為 100px
              const bodyRect = document.body.getBoundingClientRect().top;
              const elementRect = targetElement.getBoundingClientRect().top;
              const elementPosition = elementRect - bodyRect;
              const offsetPosition = elementPosition - offset;

              window.scrollTo({
                  top: offsetPosition,
                  behavior: 'smooth'
              });
          }
  }
  }
};
</script>

<style scoped>

</style>
